import { LocalstorageService } from './../services/localstorage.service';
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { LoginService } from '../services/login.service';
import { NbGlobalPhysicalPosition, NbGlobalPosition, NbToastrService, NbComponentStatus } from '@nebular/theme';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { TimeZoneDetails } from '../models/time-zone-details';
import { SignupService } from '../services/signup.service';
import { ProfileService } from '../services/profile.service';
import { DatePipe } from '@angular/common';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import * as $ from "jquery";
import { ActivatedRoute, Router } from '@angular/router';
import { UserInformationService } from '../services/userInformation.service';
import { patterns } from '../../assets/patterns';
import { MessageemitterService } from '../services/messageemitter.service';
import { HttpErrorResponse } from '@angular/common/http';

const moment = _rollupMoment || _moment;

@Component({
  selector: 'welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  companyName: any;
  customerKey: string;
  userName: any;
  message: string;
  imagePath: any;
  imgURL: string | ArrayBuffer;
  fileData: File;
  userId: string;
  loading: boolean;
  preSignUpTZDetails: TimeZoneDetails[];
  customerResponse: any;
  customerHierachy: String;
  userAssociation: any;
  password: any;
  destroyByClick = true;
  duration = 4000;
  hasIcon = true;
  position: NbGlobalPosition = NbGlobalPhysicalPosition.TOP_RIGHT;
  preventDuplicates = false;
  statusSuccess: 'success';
  statusFailure: 'warning'
  formProfileDetails: UntypedFormGroup;
  weekDayArr: any;
  dayArr = [
    { key: '1', day: 'S', value: false },
    { key: '2', day: 'M', value: false },
    { key: '3', day: 'T', value: false },
    { key: '4', day: 'W', value: false },
    { key: '5', day: 'T', value: false },
    { key: '6', day: 'F', value: false },
    { key: '7', day: 'S', value: false },
  ];
  weekdays: string;
  dayCheckboxGroup: UntypedFormArray;
  id: number;
  invalidCredentials: boolean;
  RoleDescription: any;
  CompanyRoleDescription: any;
  subscriptionType: any;
  customResponse: any;

  constructor(
    private http: HttpClient,
    private loginService: LoginService,
    private toastrService: NbToastrService,
    private signupService: SignupService,
    private formBuilder: UntypedFormBuilder,
    private profileService: ProfileService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private userInformationService: UserInformationService,
    private router: Router,
    private localStorageService: LocalstorageService
  ) {
    this.route.params.subscribe(params => {
      this.id = parseInt((params.customerId.replace(/,/g, '')));
    })
  }

  ngOnInit() {
    this.signupService.getTimeZone().subscribe((data: any) => {
      this.preSignUpTZDetails = data;
    });

    this.profileService.getCustomerUserRoleType().subscribe(resMappingDetail => {
      this.RoleDescription = resMappingDetail;
    });

    this.dayCheckboxGroup = new UntypedFormArray(this.dayArr.map(item => new UntypedFormGroup({
      id: new UntypedFormControl(item.key),
      text: new UntypedFormControl(item.day),
      checkbox: new UntypedFormControl(item.value)
    })));

    this.formProfileDetails = this.formBuilder.group({
      CustomerfirstName: ['', [Validators.required, Validators.pattern(patterns.textPattern)]],
      CustomerlastName: ['', [Validators.required, Validators.pattern(patterns.namePattern)]],
      CustomerTitle: [''],
      CustomerCellPhone: ['', Validators.pattern(patterns.mobNumPattern)],
      CustomerEmail: [''],
      CustomerUserName: [''],
      CustomerPassword: ['', [Validators.required, Validators.pattern(patterns.passwordPattern)]],
      Customerconfpassword: ['', Validators.required],
      CustomerView: [''],
      CustomerAssignedTo: [''],
      CustomerApprovalLimitRepairs: [''],
      CustomerApprovalTires: [''],
      CustomerApprovalStart: [''],
      CustomerApprovalStop: [''],
      CustomerHourAvailable: [''],
      CustomerRole: [''],
      CustomerIsApprover: [''],
      CustomerTimeZone: [''],
      CustomerWeekday: this.dayCheckboxGroup
    });

    if (this.id != undefined) {
      this.loading = true;
      this.profileService.getCustomerUserInformationById(this.id).subscribe(res => {
        if (res.length) {
          if (res[0].password) {
            this.signupService.setShowMessage(false);
            this.router.navigate(['/login']);
          } else {
            this.signupService.setShowMessage(true);
            this.profileService.getCompanyRoleCustomized(res[0].legacyCustomerKeyID).subscribe(resMappingDetail => {
              this.CompanyRoleDescription = resMappingDetail;
            });

            this.userInformationService.getUserInformationByEmail(res[0].userName).subscribe((res) => {
              this.customerResponse = res;
              this.weekDayArr = JSON.stringify(res.weekDay).split(',');
              this.userId = res.customerUserInformationId;
              this.customerKey = res.legacyCustomerKeyId;
              this.companyName = res.companyName;
              let imageURL = res.image;
              this.weekdays = res.weekDay;
              this.customerHierachy = res.hierachy;
              this.userAssociation = res.userAssociation;
              this.subscriptionType = res.subScriptionType;

              if (imageURL == "" || imageURL == undefined || imageURL == null) {
                this.imgURL = "../../assets/images/user-image.png";
              } else {
                this.imgURL = imageURL;
              }

              for (let i = 0; i < this.weekDayArr.length; i++) {
                let selectedItems = [];
                selectedItems = this.dayArr.filter((item) => parseInt(item.key) == this.weekDayArr[i]);
                if (selectedItems.toString() != "") {
                  this.dayArr.filter((item) => parseInt(item.key) == this.weekDayArr[i]).map((item) => item.value = true);
                }
              }

              this.formProfileDetails.get("CustomerfirstName").setValue(res.firstname);
              this.formProfileDetails.get("CustomerlastName").setValue(res.lastname);
              this.formProfileDetails.get("CustomerCellPhone").setValue(res.phone);
              this.formProfileDetails.get("CustomerTitle").setValue(res.title);
              this.formProfileDetails.get("CustomerEmail").setValue(res.email);
              this.formProfileDetails.get("CustomerUserName").setValue(res.email);
              this.formProfileDetails.get("CustomerPassword").setValue("");
              this.formProfileDetails.get("CustomerView").setValue(res.view);
              this.formProfileDetails.get("CustomerAssignedTo").setValue(res.assignedTo);
              this.formProfileDetails.get("CustomerRole").setValue(res.role);
              this.formProfileDetails.get("CustomerApprovalLimitRepairs").setValue(res.approvalLimitRepairsTow);
              this.formProfileDetails.get("CustomerApprovalTires").setValue(res.approvalLimitTire);
              this.formProfileDetails.get("CustomerApprovalStart").setValue(res.approvalAvailabilityStart == null ? "" : res.approvalAvailabilityStart);
              this.formProfileDetails.get("CustomerApprovalStop").setValue(res.approvalAvailabilityStop == null ? "" : res.approvalAvailabilityStop);
              this.formProfileDetails.get("CustomerHourAvailable").setValue(res.available24Hours != '0' ? true : false);
              this.formProfileDetails.get("CustomerIsApprover").setValue(res.notAnApprover != '0' ? true : false);
              this.formProfileDetails.get("CustomerTimeZone").setValue(res.timeZoneTypeId == 0 ? "America/New_York" : res.timeZoneTypeId);
              this.formProfileDetails.get("CustomerEmail").disable();
              this.formProfileDetails.get("CustomerUserName").disable();
              this.formProfileDetails.get("CustomerView").disable();
              this.formProfileDetails.get("CustomerAssignedTo").disable();
              this.formProfileDetails.get("CustomerRole").disable();
              this.formProfileDetails.get("CustomerIsApprover").disable();
              this.formProfileDetails.get("CustomerApprovalLimitRepairs").disable();
              this.formProfileDetails.get("CustomerApprovalTires").disable();
              this.loading = false;
            });

          }
        } else {
          this.signupService.setShowMessage(true);
          this.router.navigate(['/notActive']);
        }
      });
    } else {
      this.router.navigate(['/login']);
    }

    this.dayCheckboxGroup.valueChanges.subscribe((value) => {
      this.weekdays = this.mapItems(value).toString();
      if (this.weekdays.split(',').length == 7) {
        this.formProfileDetails.get("CustomerHourAvailable").setValue(true);
      } else {
        this.formProfileDetails.get("CustomerHourAvailable").setValue(false);
      }
    });
  }

  mapItems(items) {
    let selectedItems = items.filter((item) => item.checkbox).map((item) => item.id);
    return selectedItems.length ? selectedItems : "";
  }

  preview(files, event) {
    this.fileData = <File>event.target.files[0];
    const formData = new FormData();
    formData.append("file", this.fileData);
    formData.append("path", "customerPortal/ProfilePictures");
    if (files.length === 0)
      return;

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }
    this.loading = true;
    var reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
      this.http.post(environment.baseUrl + "api/customers/uploadFile", formData).subscribe(resFileDetail => {
        if (resFileDetail['status'] == "Success") {
          let msg = "Profile picture updated.!";
          this.showToast(this.statusSuccess, this.position, msg);

          const deleteImg = new FormData();
          deleteImg.append("file_name", sessionStorage.getItem('image'));

          this.http.post(environment.baseUrl + "api/customers/deleteFile", deleteImg)
            .subscribe((response: any) => {
              this.loading = false;
            }, (error) => {
              this.loading = false;
              console.error('WelcomeComponent_preview', error);
            });
        } else {
          let msg = "Failed to update profile picture.!"
          this.showToast(this.statusFailure, this.position, msg);
        }
        let data = {
          "user_id": this.userId,
          "image_url": resFileDetail['url']
        }
        this.http.post(environment.baseUrl + "api/customers/updateImageURL", data)
          .subscribe((response: any) => {
            sessionStorage.setItem('image', resFileDetail['url']);
            this.loginService.setProfilePicture(resFileDetail['url']);
            this.loading = false;
          }, (error) => {
            this.loading = false;
            console.error('WelcomeComponent_preview', error);
          });
      });
    }
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: this.destroyByClick,
      duration: this.duration,
      hasIcon: this.hasIcon,
      position: this.position,
      preventDuplicates: this.preventDuplicates,
    };
    const footer = "";
    const titleContent = body;
    this.toastrService.show(
      footer,
      `${titleContent}`,
      config);
  }

  updateCustomerProfile() {
    if (this.formProfileDetails.invalid) {
      return false
    }
    let customerKey = this.customerKey;
    if (this.customerHierachy === "Region") {
      customerKey = this.userAssociation;
    }
    let CustomerDetails = {
      "customerUserID": this.customerResponse.customerUserInformationId,
      "customerFirstName": this.formProfileDetails.get("CustomerfirstName").value,
      "customerLastName": this.formProfileDetails.get("CustomerlastName").value,
      "customerTimeZone": this.formProfileDetails.get("CustomerTimeZone").value,
      "customerTitle": this.formProfileDetails.get("CustomerTitle").value,
      "customerView": this.formProfileDetails.get("CustomerView").value,
      "customerAssignedTo": 0,
      "customerApprovalLimitRepairsTow": this.formProfileDetails.get("CustomerApprovalLimitRepairs").value,
      "customerApprovalLimitTire": this.formProfileDetails.get("CustomerApprovalTires").value,
      "customerApprovalAvailabilityStart": this.formProfileDetails.get("CustomerApprovalStart").value,
      "customerApprovalAvailabilityStop": this.formProfileDetails.get("CustomerApprovalStop").value,
      "customerWeekDay": this.weekdays,
      "customerNotAnApprover": this.formProfileDetails.get("CustomerIsApprover").value == true ? 1 : 0,
      "customerAvailable24Hours": this.formProfileDetails.get("CustomerHourAvailable").value == true ? 1 : 0,
      "customerPhone": this.formProfileDetails.get("CustomerCellPhone").value,
      "customerPassword": this.formProfileDetails.get("CustomerPassword").value,
      "customerKey": customerKey,
      "customerHierarchy": this.customerHierachy,
      "customerEmail": this.formProfileDetails.get("CustomerEmail").value
    }
    this.loading = true;
    this.profileService.updateInviteUserProfile(CustomerDetails).subscribe(res => {
      if (res) {
        let msg = "Profile created successfully.!";
        // this.showToast(this.statusSuccess, this.position, msg);
        // this.router.navigate(['/login']);
        this.navigateToDashboard();
      } else {
        let msg = "Failed to update.!"
        this.showToast(this.statusFailure, this.position, msg);
        this.loading = false;
      }
    });
  }

  navigateToDashboard() {
    this.loading = true;
    this.loginService.userAuthentication(this.formProfileDetails.get("CustomerEmail").value, this.formProfileDetails.get("CustomerPassword").value).subscribe((response: any) => {
      this.loading = false;
      MessageemitterService.get("loginStatus").emit(['true']);
      this.localStorageService.setAuthorizationData(response);
      sessionStorage.setItem('currentUserEmail', this.formProfileDetails.get("CustomerEmail").value);
      sessionStorage.setItem('emailInLocalStorage', this.formProfileDetails.get("CustomerEmail").value);
    },
      (err: HttpErrorResponse) => {
        this.loading = false;
        this.router.navigate(['/signup-complete']);
        return;
      }, () => {
        this.loading = true;
        this.userInformationService.getUserInformationByEmail(sessionStorage.getItem("currentUserEmail")).subscribe((res) => {
          this.loading = false;
          const userDetails = {
            'firstname': res.firstname,
            'middlename': res.middlename,
            'lastname': res.lastname,
            'email': res.email,
            'billingEmail': res.billingEmail,
            'phone': res.phone,
            'breakDownPhone': res.officePhone,
            'address': res.address,
            'city': res.city,
            'state': res.stateTypeId,
            'zip': res.zip,
            'isDemoComplete': res.isDemoComplete,
            'subScriptionType': res.subScriptionType,
            'viewProviderInvoice': res.viewProviderInvoice,
          };

          sessionStorage.setItem('userDetails', JSON.stringify(userDetails));
          sessionStorage.setItem('companyName', res.companyName);
          sessionStorage.setItem('customerTimezone', res.timeZoneTypeId == 0 ? "America/New_York" : res.timeZoneTypeId);

          this.customResponse = res;
        }, (err) => {
          this.loading = false;
          console.error('WelcomeComponent_navigateToDashboard', err);
        },
          () => {
            sessionStorage.setItem('customerUserInformationId', this.customResponse.customerUserInformationId);
            sessionStorage.setItem('legacyCustomerKeyId', this.customResponse.legacyCustomerKeyId);
            sessionStorage.setItem('fleetCustomerId', this.customResponse.fleetCustomerId);
            sessionStorage.setItem('customerParentInformationID', this.customResponse.customerParentInformationID);
            sessionStorage.setItem('userAssociation', this.customResponse.userAssociation);
            sessionStorage.setItem('subCustomerId', this.customResponse.legacySubCustomerKey);
            sessionStorage.setItem('fleetCustomerId', this.customResponse.fleetCustomerId);
            sessionStorage.setItem('image', this.customResponse.image);
            sessionStorage.setItem('subCustomerId', this.customResponse.legacySubCustomerKey);
            sessionStorage.setItem('doNotShowTour', this.customResponse.doNotShowTour);
            sessionStorage.setItem('approvalAvailabilityStart', this.customResponse.approvalAvailabilityStart);
            sessionStorage.setItem('approvalAvailabilityStop', this.customResponse.approvalAvailabilityStop);
            sessionStorage.setItem('approvalLimitRepairsTow', this.customResponse.approvalLimitRepairsTow);
            sessionStorage.setItem('approvalLimitTire', this.customResponse.approvalLimitTire);
            sessionStorage.setItem('assignedTo', this.customResponse.assignedTo);
            sessionStorage.setItem('available24Hours', this.customResponse.available24Hours);
            sessionStorage.setItem('notAnApprover', this.customResponse.notAnApprover);
            sessionStorage.setItem('weekDay', this.customResponse.weekDay);
            sessionStorage.setItem('title', this.customResponse.title);
            sessionStorage.setItem('hierachy', this.customResponse.hierachy);
            sessionStorage.setItem('view', this.customResponse.view);
            sessionStorage.setItem('role', this.customResponse.role);
            sessionStorage.setItem('loggedInRegionName', this.customResponse.regionName);
            sessionStorage.setItem('loggedInDivisionName', this.customResponse.divisionName);
            sessionStorage.setItem('loggedInLocationName', this.customResponse.locationName);

            sessionStorage.setItem('ersSubcustomerId', this.customResponse.ersSubcustomerId);
            sessionStorage.setItem('ersDivisionId', this.customResponse.ersDivisionId);
            sessionStorage.setItem('ersLocationId', this.customResponse.ersLocationId);
            sessionStorage.setItem('fleetSubcustomerId', this.customResponse.fleetSubcustomerId);
            sessionStorage.setItem('fleetDivisionId', this.customResponse.fleetDivisionId);
            sessionStorage.setItem('fleetLocationId', this.customResponse.fleetLocationId);
            sessionStorage.setItem('agreementURL', this.customResponse.agreementTemplateURL);
            sessionStorage.setItem('subscriptionType', this.customResponse.subScriptionType);
            sessionStorage.setItem('restrictWOsDate', this.customResponse.restrictWOsDate ? this.customResponse.restrictWOsDate : '');
            sessionStorage.setItem('isAgreementAccepted', this.customResponse.isAgreementAccepted);
            this.loading = false;
            this.router.navigate(['/pages']);
          });
      }
    );
  }

  setDays() {
    if (this.formProfileDetails.get("CustomerHourAvailable").value) {
      this.weekdays = "1,2,3,4,5,6,7";
      for (let i = 1; i <= 7; i++) {
        $("#" + i).prop('checked', true);
        this.dayCheckboxGroup.controls[i - 1].get("checkbox").setValue(true)
      }
    }
    if (!this.formProfileDetails.get("CustomerHourAvailable").value) {
      if (this.weekdays.split(',').length == 7) {
        this.formProfileDetails.get("CustomerHourAvailable").setValue(true);
      }
    }
  }
}
